import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { connect } from 'react-redux';

// Import des vrais composants
import AdminApp from './admin/src/App';
import FrontendApp from './frontend/App';
import ForgotPassword from './admin/src/jsx/pages/ForgotPassword';
import ResetPassword from './admin/src/jsx/pages/ResetPassword';
import ConsultantLayout from './layouts/ConsultantLayout';
import EntrepriseLayout from './layouts/EntrepriseLayout';
import ResumesPage from './pages/ResumesPage';

// Store admin
import { store as adminStore } from './admin/src/store/store';

function LoginRedirect() {
  const location = useLocation();
  return <Navigate to={`/admin/login${location.search || ''}`} replace />;
}

function App() {
  console.log('Main App rendering');
  
  return (
    <Router>
      <Routes>
        {/* Redirection /login vers /admin/login */}
        <Route path="/login" element={<LoginRedirect />} />

        {/* Password reset (global) */}
        <Route
          path="/password/forgot"
          element={
            <Provider store={adminStore}>
              <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
                <ForgotPassword />
              </div>
            </Provider>
          }
        />
        <Route
          path="/password/reset/:token"
          element={
            <Provider store={adminStore}>
              <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
                <ResetPassword />
              </div>
            </Provider>
          }
        />
        
        {/* Routes Admin - doit être avant les routes frontend */}
        <Route 
          path="/admin/*" 
          element={
            <Provider store={adminStore}>
              <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
                <AdminApp />
              </div>
            </Provider>
          } 
        />
        
        {/* Routes Consultant */}
        <Route 
          path="/consultant/*" 
          element={<ConsultantLayout />} 
        />
        
        {/* Route dédiée pour les CVs */}
        <Route 
          path="/account/resumes" 
          element={<ResumesPage />} 
        />
        
        {/* Routes Entreprise */}
        <Route 
          path="/entreprise/*" 
          element={<EntrepriseLayout />} 
        />
        
        {/* Routes Frontend Public */}
        <Route path="/*" element={<FrontendApp />} />
      </Routes>
    </Router>
  );
}

export default App;
